export default function partnerWithUs() {
  const onceHubButton = document.getElementById('partner-with-us-oncehub-button');
  const onceHubWidget = document.querySelector('.partner-with-us-oncehub');

  if (!onceHubButton || !onceHubWidget) {
    return;
  }

  onceHubButton.addEventListener('click', () => {
    onceHubWidget.classList.add('is-visible');
    onceHubButton.style.display = 'none';
  });
}
